import{Component}from"@theme/component";import{fetchConfig,onAnimationEnd,preloadImage}from"@theme/utilities";import{ThemeEvents,CartAddEvent,CartErrorEvent}from"@theme/events";import{cartPerformance}from"@theme/performance";import{morph}from"@theme/morph";
let sdCartMutationSequence = 0;

/**
 * Bracket one add operation, including its existing follow-up mutations.
 * Document owns the event target so detached form nodes cannot orphan completion.
 * @returns {() => void} Idempotent completion callback for the operation's finally block.
 */
function beginSdCartMutation() {
  const requestId = `product-form-${++sdCartMutationSequence}`;
  let completed = false;
  document.dispatchEvent(new CustomEvent('sd:cart-mutation', {
    detail: { phase: 'start', requestId }
  }));
  return () => {
    if (completed) return;
    completed = true;
    document.dispatchEvent(new CustomEvent('sd:cart-mutation', {
      detail: { phase: 'complete', requestId }
    }));
  };
}

export const ADD_TO_CART_TEXT_ANIMATION_DURATION=2e3;export class AddToCartComponent extends Component{requiredRefs=["addToCartButton"];#animationTimeout;#cleanupTimeout;connectedCallback(){super.connectedCallback(),this.addEventListener("pointerenter",this.#preloadImage)}disconnectedCallback(){super.disconnectedCallback(),this.#animationTimeout&&clearTimeout(this.#animationTimeout),this.#cleanupTimeout&&clearTimeout(this.#cleanupTimeout),this.removeEventListener("pointerenter",this.#preloadImage)}handleClick(event){this.animateAddToCart(),event.target.closest(".quick-add-modal")||this.#animateFlyToCart()}#preloadImage=()=>{const image=this.dataset.productVariantMedia;image&&preloadImage(image)};#animateFlyToCart(){const{addToCartButton}=this.refs,cartIcon=document.querySelector(".header-actions__cart-icon"),image=this.dataset.productVariantMedia;if(!cartIcon||!addToCartButton||!image)return;const flyToCartElement=document.createElement("fly-to-cart");flyToCartElement.style.setProperty("background-image",`url(${image})`),flyToCartElement.source=addToCartButton,flyToCartElement.destination=cartIcon,document.body.appendChild(flyToCartElement)}animateAddToCart(){const{addToCartButton}=this.refs;this.#animationTimeout&&clearTimeout(this.#animationTimeout),this.#cleanupTimeout&&clearTimeout(this.#cleanupTimeout),addToCartButton.classList.contains("atc-added")||addToCartButton.classList.add("atc-added"),this.#animationTimeout=setTimeout(()=>{this.#cleanupTimeout=setTimeout(()=>{this.refs.addToCartButton.classList.remove("atc-added")},10)},ADD_TO_CART_TEXT_ANIMATION_DURATION)}}customElements.get("add-to-cart-component")||customElements.define("add-to-cart-component",AddToCartComponent);class ProductFormComponent extends Component{requiredRefs=["variantId","liveRegion"];#abortController=new AbortController;#timeout;connectedCallback(){super.connectedCallback();const{signal}=this.#abortController;this.closest(".shopify-section, dialog")?.addEventListener(ThemeEvents.variantUpdate,this.#onVariantUpdate,{signal})}disconnectedCallback(){super.disconnectedCallback(),this.#abortController.abort()}async handleSubmit(event){const{addToCartTextError}=this.refs;if(event.preventDefault(),this.#timeout&&clearTimeout(this.#timeout),this.refs.addToCartButtonContainer?.refs.addToCartButton?.getAttribute("disabled")==="true")return;const form=this.querySelector("form");if(!form)throw new Error("Product form element missing");const formData=new FormData(form),cartItemsComponents=document.querySelectorAll("cart-items-component");let cartItemComponentsSectionIds=[];cartItemsComponents.forEach(item=>{item instanceof HTMLElement&&item.dataset.sectionId&&cartItemComponentsSectionIds.push(item.dataset.sectionId),formData.append("sections",cartItemComponentsSectionIds.join(","))});const fetchCfg=fetchConfig("javascript",{body:formData});const completeMutation=beginSdCartMutation();try{await fetch(Theme.routes.root+"cart/add.js",{...fetchCfg,headers:{...fetchCfg.headers,Accept:"text/html"}}).then(response=>response.json()).then(response=>{if(response.status){if(window.dispatchEvent(new CartErrorEvent(this.id,response.message)),!addToCartTextError)return;addToCartTextError.classList.remove("hidden");const textNode=addToCartTextError.childNodes[2];if(textNode)textNode.textContent=response.message;else{const newTextNode=document.createTextNode(response.message);addToCartTextError.appendChild(newTextNode)}this.#setLiveRegionText(response.message),this.#timeout=setTimeout(()=>{addToCartTextError&&(addToCartTextError.classList.add("hidden"),this.#clearLiveRegionText())},1e4),this.dispatchEvent(new CartAddEvent({},this.id,{didError:!0,source:"product-form-component",itemCount:Number(formData.get("quantity")),productId:this.dataset.productId}));return}else{const id=formData.get("id");if(addToCartTextError&&(addToCartTextError.classList.add("hidden"),addToCartTextError.removeAttribute("aria-live")),!id)throw new Error("Form ID is required");if(this.refs.addToCartButtonContainer?.refs.addToCartButton){const addedText=this.refs.addToCartButtonContainer.refs.addToCartButton.querySelector(".add-to-cart-text--added")?.textContent?.trim()||Theme.translations.added;this.#setLiveRegionText(addedText),setTimeout(()=>{this.#clearLiveRegionText()},5e3)}this.dispatchEvent(new CartAddEvent({},id.toString(),{source:"product-form-component",itemCount:Number(formData.get("quantity")),productId:this.dataset.productId,sections:response.sections}))}})}catch(error){console.error(error);const message=Theme.translations.addToCartError;window.dispatchEvent(new CartErrorEvent(this.id,message));if(addToCartTextError){addToCartTextError.classList.remove("hidden");const textNode=addToCartTextError.childNodes[2];if(textNode)textNode.textContent=message;else addToCartTextError.appendChild(document.createTextNode(message))}this.#setLiveRegionText(message)}finally{completeMutation();cartPerformance.measureFromEvent("add:user-action",event)}}#setLiveRegionText(text){const liveRegion=this.refs.liveRegion;liveRegion.textContent=text}#clearLiveRegionText(){const liveRegion=this.refs.liveRegion;liveRegion.textContent=""}#onVariantUpdate=event=>{if(event.detail.data.newProduct)this.dataset.productId=event.detail.data.newProduct.id;else if(event.detail.data.productId!==this.dataset.productId)return;const{variantId,addToCartButtonContainer}=this.refs,currentAddToCartButton=addToCartButtonContainer?.refs.addToCartButton,newAddToCartButton=event.detail.data.html.querySelector('[ref="addToCartButton"]');if(currentAddToCartButton&&(event.detail.resource==null||event.detail.resource.available==!1?(currentAddToCartButton.setAttribute("disabled","true"),this.refs.acceleratedCheckoutButtonContainer?.setAttribute("hidden","true")):(addToCartButtonContainer.refs.addToCartButton.removeAttribute("disabled"),this.refs.acceleratedCheckoutButtonContainer?.removeAttribute("hidden")),newAddToCartButton&&morph(currentAddToCartButton,newAddToCartButton),variantId.value=event.detail.resource.id??"",event.detail.resource)){const productVariantMedia=event.detail.resource.featured_media?.preview_image?.src;productVariantMedia&&addToCartButtonContainer?.setAttribute("data-product-variant-media",productVariantMedia+"&width=100")}}}customElements.get("product-form-component")||customElements.define("product-form-component",ProductFormComponent);class FlyToCart extends HTMLElement{source;destination;connectedCallback(){this.#animate()}#animate(){const rect=this.getBoundingClientRect(),sourceRect=this.source.getBoundingClientRect(),destinationRect=this.destination.getBoundingClientRect(),offset={x:rect.width/2,y:rect.height/2},startPoint={x:sourceRect.left+sourceRect.width/2-offset.x,y:sourceRect.top+sourceRect.height/2-offset.y},endPoint={x:destinationRect.left+destinationRect.width/2-offset.x,y:destinationRect.top+destinationRect.height/2-offset.y},controlPoint1={x:startPoint.x,y:startPoint.y-200},controlPoint2={x:endPoint.x-300,y:endPoint.y-100};let startTime=null;const duration=600;this.style.opacity="1";const animate=currentTime=>{startTime||(startTime=currentTime);const elapsed=currentTime-startTime,progress=Math.min(elapsed/duration,1),position=bezierPoint(progress,startPoint,controlPoint1,controlPoint2,endPoint);this.style.setProperty("--x",`${position.x}px`),this.style.setProperty("--y",`${position.y}px`);const scale=1-progress*.5;this.style.setProperty("--scale",`${scale}`),progress<1?requestAnimationFrame(animate):(this.style.opacity="0",onAnimationEnd(this,()=>this.remove()))};this.style.setProperty("--x",`${startPoint.x}px`),this.style.setProperty("--y",`${startPoint.y}px`),requestAnimationFrame(animate)}}function bezierPoint(t,p0,p1,p2,p3){const cX=3*(p1.x-p0.x),bX=3*(p2.x-p1.x)-cX,aX=p3.x-p0.x-cX-bX,cY=3*(p1.y-p0.y),bY=3*(p2.y-p1.y)-cY,aY=p3.y-p0.y-cY-bY,x=aX*Math.pow(t,3)+bX*Math.pow(t,2)+cX*t+p0.x,y=aY*Math.pow(t,3)+bY*Math.pow(t,2)+cY*t+p0.y;return{x,y}}customElements.get("fly-to-cart")||customElements.define("fly-to-cart",FlyToCart),(function(){const PRODUCT_ID="7853598048340",BODY_MODE_CLASS="sofa-bundle-mode-active";let currentMode="single";function isTargetProductPage(){return!!(document.querySelector('product-form-component[data-product-id="'+PRODUCT_ID+'"]')||document.getElementById("sofa-bundle-wrap"))}function normalizeValue(value){return String(value||"").toLowerCase().replace(/×/g,"x").replace(/grey/g,"gray").replace(/\s+/g,"").trim()}function sameValue(left,right){return normalizeValue(left)===normalizeValue(right)}function getVariants(){const product=window.meta&&window.meta.product&&String(window.meta.product.id)===PRODUCT_ID?window.meta.product:null;return!product||!Array.isArray(product.variants)?[]:product.variants.map(variant=>{const parts=String(variant.public_title||"").split(" / ");return{id:variant.id,color:parts[0]||"",size:parts[1]||""}})}function getOptionGroups(){return Array.from(document.querySelectorAll("variant-picker .variant-option"))}function findOptionGroup(names){return getOptionGroups().find(group=>{const select=group.querySelector("select"),label=group.querySelector("label"),text=(label&&label.textContent||select&&select.name||"").toLowerCase();return names.some(name=>text.indexOf(name)>-1)})}function getGroupValue(group){const select=group?group.querySelector("select"):null;if(select&&select.value)return select.value;const checked=group?group.querySelector('input[type="radio"]:checked'):null;return checked&&checked.value?checked.value:""}function getSelectedVariant(){const color=getGroupValue(findOptionGroup(["color","colour"])),size=getGroupValue(findOptionGroup(["specification","size"]));return!color||!size?null:getVariants().find(variant=>sameValue(variant.color,color)&&sameValue(variant.size,size))||null}function getSingleForms(){return Array.from(document.querySelectorAll('product-form-component[data-product-id="'+PRODUCT_ID+'"] form[action*="/cart/add"]'))}function syncSelectedVariant(){const variant=getSelectedVariant();return variant?(getSingleForms().forEach(form=>{form.querySelectorAll('[name="id"]').forEach(input=>{"value"in input&&(input.value=String(variant.id))})}),variant):null}function scheduleSync(){window.setTimeout(syncSelectedVariant,0),window.setTimeout(syncSelectedVariant,120),window.setTimeout(syncSelectedVariant,350)}function markSingleControls(){const specificationGroup=findOptionGroup(["specification","size"]);specificationGroup&&specificationGroup.classList.add("sofa-single-purchase-hidden"),document.querySelectorAll("quantity-selector-component, add-to-cart-component, .accelerated-checkout-block, .shopify-payment-button, .product-form-text__error").forEach(element=>{element.classList.add("sofa-single-purchase-hidden")})}function applyMode(mode){const wrap=document.getElementById("sofa-bundle-wrap"),panel=document.getElementById("sofa-bundle-panel");if(!wrap||!panel)return;currentMode=mode==="bundle"?"bundle":"single";const isBundleMode=currentMode==="bundle";document.body.classList.toggle(BODY_MODE_CLASS,isBundleMode),panel.hidden=!isBundleMode,wrap.querySelectorAll("[data-purchase-mode]").forEach(button=>{button.classList.toggle("is-active",button.getAttribute("data-purchase-mode")===currentMode)}),isBundleMode||syncSelectedVariant()}function positionBundleControls(){const wrap=document.getElementById("sofa-bundle-wrap");if(!wrap)return;const colorGroup=findOptionGroup(["color","colour"]),specificationGroup=findOptionGroup(["specification","size"]);colorGroup&&colorGroup.parentNode?colorGroup.parentNode.insertBefore(wrap,colorGroup.nextSibling):specificationGroup&&specificationGroup.parentNode&&specificationGroup.parentNode.insertBefore(wrap,specificationGroup),markSingleControls(),wrap.style.display="",applyMode(currentMode)}function schedulePosition(){window.setTimeout(positionBundleControls,0),window.setTimeout(positionBundleControls,200),window.setTimeout(positionBundleControls,600)}function install(){isTargetProductPage()&&(scheduleSync(),schedulePosition(),document.addEventListener("change",function(event){event.target instanceof HTMLElement&&event.target.closest("variant-picker")&&(scheduleSync(),schedulePosition())},!0),document.addEventListener("variant:update",function(event){const data=(event.detail||{}).data||{};data.productId&&data.productId!==PRODUCT_ID||(scheduleSync(),schedulePosition())}),document.addEventListener("click",function(event){const target=event.target;if(!(target instanceof HTMLElement))return;const modeButton=target.closest("#sofa-bundle-wrap [data-purchase-mode]");modeButton&&(currentMode=modeButton.getAttribute("data-purchase-mode")==="bundle"?"bundle":"single",window.setTimeout(function(){applyMode(currentMode)},0)),!document.body.classList.contains(BODY_MODE_CLASS)&&target.closest('button[name="add"], add-to-cart-component')&&syncSelectedVariant()},!0),document.addEventListener("submit",function(event){const form=event.target;form instanceof HTMLFormElement&&form.closest('product-form-component[data-product-id="'+PRODUCT_ID+'"]')&&!document.body.classList.contains(BODY_MODE_CLASS)&&syncSelectedVariant()},!0))}document.readyState==="loading"?document.addEventListener("DOMContentLoaded",install):install()})();
//# sourceMappingURL=/cdn/shop/t/4/assets/product-form.js.map?x=1777736847

/* Boho plush sofa cover bundle selector for product 7683732373588. */
(function () {
  const PRODUCT_ID = '7683732373588';
  const WRAP_ID = 'boho-bundle-wrap';
  const BODY_MODE_CLASS = 'boho-bundle-mode-active';
  const HIDDEN_CLASS = 'boho-single-purchase-hidden';
  const DISCOUNT_CODES = { one: 'BOHO10', other: 'BOHO15' };

  const BUNDLES = {
    'one-seater': {
      label: 'One Seater Bundle',
      discountPct: 0.10,
      code: DISCOUNT_CODES.one,
      items: [
        { size: 'Backrest 91.44cmx91.44cm', qty: 1, label: '1 x Back rest (91.44cm × 91.44cm)' },
        { size: 'Armchair 71.12cmx71.12cm', qty: 1, label: '1 x 1 seater cover (91.44cm × 91.44cm)' },
        { size: 'Armrest 71.12cmx71.12cm', qty: 2, label: '2 x Side rest (71.12cm × 71.12cm)' }
      ]
    },
    'two-seater': {
      label: 'Two Seater Bundle',
      discountPct: 0.15,
      code: DISCOUNT_CODES.other,
      items: [
        { size: 'Backrest 91.44cmx91.44cm', qty: 2, label: '2 x Back rest (91.44cm × 91.44cm)' },
        { size: 'Loveseat 91.44cmx160.02cm', qty: 1, label: '1 x 2 seater seat cover (91.44cm × 160.02cm)' },
        { size: 'Armrest 71.12cmx71.12cm', qty: 2, label: '2 x Side rest (71.12cm × 71.12cm)' }
      ]
    },
    'three-seater': {
      label: 'Three Seater Bundle',
      discountPct: 0.15,
      code: DISCOUNT_CODES.other,
      items: [
        { size: 'Backrest 91.44cmx91.44cm', qty: 3, label: '3 x Back rest (91.44cm × 91.44cm)' },
        { size: '3-Seater 91.44cmx180.34cm', qty: 1, label: '1 x 3 seater seat cover (91.44cm × 180.34cm)' },
        { size: 'Armrest 71.12cmx71.12cm', qty: 2, label: '2 x Side rest (71.12cm × 71.12cm)' }
      ]
    },
    'l-shaped': {
      label: 'L-Shaped Bundle',
      discountPct: 0.15,
      code: DISCOUNT_CODES.other,
      items: [
        { size: 'Backrest 91.44cmx91.44cm', qty: 4, label: '4 x Back rest (91.44cm × 91.44cm)' },
        { size: '4-Seater 91.44cmx210.82cm', qty: 1, label: '1 x 4 seater seat cover (91.44cm × 210.82cm)' },
        { size: 'Loveseat 91.44cmx160.02cm', qty: 1, label: '1 x chaise / return seat cover (91.44cm × 160.02cm)' },
        { size: 'Armrest 71.12cmx71.12cm', qty: 2, label: '2 x Side rest (71.12cm × 71.12cm)' }
      ]
    }
  };

  let activeBundle = null;
  let currentMode = 'single';
  let singleAddInFlight = false;

  function isTargetProductPage() {
    return !!document.querySelector('product-form-component[data-product-id="' + PRODUCT_ID + '"]');
  }

  function normalizeValue(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/\u00d7/g, 'x')
      .replace(/grey/g, 'gray')
      .replace(/\s+/g, '')
      .trim();
  }

  function sameValue(left, right) {
    return normalizeValue(left) === normalizeValue(right);
  }

  function getVariants() {
    const product = window.meta && window.meta.product && String(window.meta.product.id) === PRODUCT_ID ? window.meta.product : null;
    if (!product || !Array.isArray(product.variants)) return [];
    return product.variants.map((variant) => {
      const parts = String(variant.public_title || '').split(' / ');
      return {
        id: variant.id,
        color: parts[0] || '',
        size: parts[1] || '',
        price: variant.price,
        available: variant.available !== false
      };
    });
  }

  function getVariantPicker() {
    return document.querySelector('variant-picker[data-product-id="' + PRODUCT_ID + '"]');
  }

  function getOptionGroups() {
    const picker = getVariantPicker();
    return picker ? Array.from(picker.querySelectorAll('.variant-option')) : [];
  }

  function findOptionGroup(names) {
    return getOptionGroups().find((group) => {
      const select = group.querySelector('select');
      const label = group.querySelector('label');
      const text = ((label && label.textContent) || (select && select.name) || '').toLowerCase();
      return names.some((name) => text.indexOf(name) > -1);
    });
  }

  function getGroupValue(group) {
    const select = group ? group.querySelector('select') : null;
    if (select && select.value) return select.value;
    const checked = group ? group.querySelector('input[type="radio"]:checked') : null;
    return checked && checked.value ? checked.value : '';
  }

  function getColor() {
    return getGroupValue(findOptionGroup(['color', 'colour'])) || (getVariants()[0] && getVariants()[0].color) || '';
  }

  function getSize() {
    return getGroupValue(findOptionGroup(['size', 'specification'])) || (getVariants()[0] && getVariants()[0].size) || '';
  }

  function getSelectedVariant() {
    const color = getColor();
    const size = getSize();
    if (!color || !size) return null;
    return getVariants().find((variant) => sameValue(variant.color, color) && sameValue(variant.size, size)) || null;
  }

  function getProductForms() {
    return Array.from(document.querySelectorAll('product-form-component[data-product-id="' + PRODUCT_ID + '"] form[action*="/cart/add"]'));
  }

  function getAddButtonFromForm(form) {
    return form.querySelector('button[name="add"], add-to-cart-component button[type="submit"]');
  }

  function setSingleAddButtonsDisabled(disabled) {
    getProductForms().forEach((form) => {
      const button = getAddButtonFromForm(form);
      if (!button) return;
      if (disabled) button.setAttribute('disabled', 'true');
      else button.removeAttribute('disabled');
    });
  }

  function syncSelectedVariant() {
    const variant = getSelectedVariant();
    if (!variant) {
      setSingleAddButtonsDisabled(true);
      return null;
    }
    getProductForms().forEach((form) => {
      form.querySelectorAll('[name="id"]').forEach((input) => {
        if ('value' in input) input.value = String(variant.id);
      });
    });
    setSingleAddButtonsDisabled(!variant.available);
    return variant;
  }

  function scheduleSync() {
    window.setTimeout(syncSelectedVariant, 0);
    window.setTimeout(syncSelectedVariant, 150);
    window.setTimeout(syncSelectedVariant, 400);
  }

  function formatMoney(cents) {
    return (cents / 100).toLocaleString('en-AU', { style: 'currency', currency: 'AUD' });
  }

  function getCartSectionIds() {
    const ids = new Set();
    document.querySelectorAll('cart-items-component[data-section-id], cart-discount-component[data-section-id]').forEach((element) => {
      if (element instanceof HTMLElement && element.dataset.sectionId) ids.add(element.dataset.sectionId);
    });
    return Array.from(ids);
  }

  function getQuantityFromForm(form) {
    const quantityInput = form.querySelector('[name="quantity"]');
    const quantity = parseInt(quantityInput && quantityInput.value ? quantityInput.value : '1', 10);
    return Number.isFinite(quantity) && quantity > 0 ? quantity : 1;
  }

  function setAddButtonText(button, text) {
    if (!(button instanceof HTMLElement)) return;
    const label = button.querySelector('.add-to-cart-text__content');
    if (label) {
      if (!button.dataset.bohoOriginalText) button.dataset.bohoOriginalText = label.textContent || 'Add to cart';
      label.textContent = text;
      return;
    }
    if (!button.dataset.bohoOriginalText) button.dataset.bohoOriginalText = button.textContent || 'Add to cart';
    button.textContent = text;
  }

  function restoreAddButtonText(button) {
    if (!(button instanceof HTMLElement) || !button.dataset.bohoOriginalText) return;
    const label = button.querySelector('.add-to-cart-text__content');
    if (label) label.textContent = button.dataset.bohoOriginalText;
    else button.textContent = button.dataset.bohoOriginalText;
  }

  async function addSingleItemToCart(variant, quantity) {
    const sectionIds = getCartSectionIds();
    const payload = { id: variant.id, quantity };
    if (sectionIds.length) payload.sections = sectionIds.join(',');
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    });
    const data = await response.json();
    if (!response.ok || data.status) throw new Error(data.description || data.message || 'Could not add this item to the cart.');
    return data;
  }

  function dispatchCartEvent(updateData, id, itemCount) {
    if (typeof CartAddEvent === 'function') {
      document.dispatchEvent(new CartAddEvent(updateData, String(id), {
        source: 'product-form-component',
        itemCount,
        productId: PRODUCT_ID,
        sections: updateData && updateData.sections ? updateData.sections : {}
      }));
    }
  }

  async function handleSingleAdd(event, form) {
    if (document.body.classList.contains(BODY_MODE_CLASS)) return;
    if (singleAddInFlight) {
      event.preventDefault();
      event.stopImmediatePropagation();
      return;
    }
    const variant = syncSelectedVariant();
    if (!variant || !variant.available) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const button = getAddButtonFromForm(form);
    const wasDisabled = button instanceof HTMLButtonElement && button.hasAttribute('disabled');
    singleAddInFlight = true;
    if (button instanceof HTMLButtonElement) {
      button.setAttribute('disabled', 'true');
      setAddButtonText(button, 'Adding...');
    }
    const completeMutation = beginSdCartMutation();
    try {
      const quantity = getQuantityFromForm(form);
      const data = await addSingleItemToCart(variant, quantity);
      dispatchCartEvent(data, variant.id, quantity);
      openCartDrawer();
    } catch (error) {
      console.error(error);
      if (button instanceof HTMLButtonElement) setAddButtonText(button, 'Could not add');
    } finally {
      completeMutation();
      window.setTimeout(() => {
        if (button instanceof HTMLButtonElement) {
          restoreAddButtonText(button);
          if (!wasDisabled) button.removeAttribute('disabled');
        }
        singleAddInFlight = false;
      }, 300);
    }
  }

  function resolveBundle(bundleKey, color) {
    const bundle = BUNDLES[bundleKey];
    if (!bundle) return null;
    const resolved = [];
    const missing = [];
    bundle.items.forEach((item) => {
      const variant = getVariants().find((candidate) => candidate.available && sameValue(candidate.color, color) && sameValue(candidate.size, item.size));
      if (!variant) {
        missing.push(item.size);
        return;
      }
      resolved.push({ variantId: variant.id, quantity: item.qty, label: item.label, price: variant.price });
    });
    return missing.length ? null : resolved;
  }

  async function addBundleToCart(items) {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items.map((item) => ({ id: item.variantId, quantity: item.quantity })) })
    });
    const data = await response.json();
    if (!response.ok || data.status) throw new Error(data.description || data.message || 'Could not add the bundle to cart.');
    return data;
  }

  function getExistingDiscountCodes() {
    const codes = [];
    document.querySelectorAll('.cart-discount__pill[data-discount-code]').forEach((element) => {
      if (element instanceof HTMLElement && element.dataset.discountCode) codes.push(element.dataset.discountCode);
    });
    return codes;
  }

  async function applyDiscountCode(code) {
    const sectionIds = getCartSectionIds();
    const existingCodes = getExistingDiscountCodes().filter((existingCode) => existingCode !== DISCOUNT_CODES.one && existingCode !== DISCOUNT_CODES.other);
    const payload = { discount: Array.from(new Set(existingCodes.concat(code))).join(',') };
    if (sectionIds.length) payload.sections = sectionIds.join(',');
    const response = await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    });
    const data = await response.json();
    if (!response.ok) throw new Error('Could not apply the bundle discount.');
    const applied = Array.isArray(data.discount_codes) && data.discount_codes.some((discount) => discount.code === code && discount.applicable === true);
    if (!applied) throw new Error('Bundle items were added, but the bundle discount code did not apply.');
    return data;
  }

  function openCartDrawer() {
    const drawer = document.querySelector('cart-drawer-component');
    if (drawer && typeof drawer.open === 'function') {
      drawer.open();
      return;
    }
    const toggle = document.querySelector('[aria-label="Open cart drawer"]');
    if (toggle instanceof HTMLElement) toggle.click();
  }

  function injectStyles() {
    if (document.getElementById('boho-bundle-style')) return;
    const style = document.createElement('style');
    style.id = 'boho-bundle-style';
    style.textContent = `
      .boho-bundle { width: 100%; margin: 14px 0 18px; color: rgb(var(--color-foreground-rgb, 18 18 18)); font: inherit; }
      .boho-bundle, .boho-bundle * { box-sizing: border-box; }
      .boho-bundle__intro { margin: 0 0 10px; color: rgba(var(--color-foreground-rgb, 18 18 18), .72); font: inherit; font-size: .94rem; line-height: 1.35; }
      .boho-bundle__mode { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 6px; padding: 4px; border: 1px solid rgba(var(--color-foreground-rgb, 18 18 18), .12); border-radius: 8px; background: rgba(var(--color-foreground-rgb, 18 18 18), .025); }
      .boho-bundle__mode-btn, .boho-bundle__btn, .boho-bundle__cta { font: inherit; min-height: 46px; border-radius: 6px; cursor: pointer; }
      .boho-bundle__mode-btn { border: 1px solid transparent; background: transparent; color: inherit; }
      .boho-bundle__mode-btn.is-active { border-color: currentColor; background: rgb(var(--color-background-rgb, 255 255 255)); }
      .boho-bundle__panel { margin-top: 14px; }
      .boho-bundle__heading { display: flex; align-items: center; justify-content: space-between; gap: 10px; margin: 0 0 12px; font: inherit; font-size: .86rem; font-weight: 700; letter-spacing: .08em; text-transform: uppercase; }
      .boho-bundle__save-pill { display: inline-flex; align-items: center; justify-content: center; min-height: 22px; padding: 3px 8px; border-radius: 999px; background: #2f7d32; color: #fff; font-size: .76rem; font-weight: 700; letter-spacing: 0; text-transform: none; white-space: nowrap; }
      .boho-bundle__options { display: grid; gap: 8px; }
      .boho-bundle__btn { width: 100%; display: flex; align-items: center; justify-content: space-between; gap: 10px; padding: 0 14px; border: 1px solid rgba(var(--color-foreground-rgb, 18 18 18), .14); background: rgb(var(--color-background-rgb, 255 255 255)); color: inherit; text-align: left; appearance: none; }
      .boho-bundle__btn.is-active { border-color: #2f7d32; background: rgba(47, 125, 50, .08); box-shadow: inset 4px 0 0 #2f7d32; font-weight: 700; }
      .boho-bundle__btn.is-active .boho-bundle__save-pill { background: #246627; }
      .boho-bundle__btn-name { min-width: 0; overflow-wrap: anywhere; }
      .boho-bundle__details { display: none; margin-top: 10px; padding: 14px; border: 1px solid rgba(var(--color-foreground-rgb, 18 18 18), .1); border-radius: 8px; background: rgba(var(--color-foreground-rgb, 18 18 18), .025); font: inherit; }
      .boho-bundle__details.is-visible { display: block; }
      .boho-bundle__details-title { margin-bottom: 8px; font-weight: 700; }
      .boho-bundle__details ul { margin: 0; padding-inline-start: 18px; }
      .boho-bundle__details li { margin-top: 4px; line-height: 1.35; overflow-wrap: anywhere; }
      .boho-bundle__pricing { margin-top: 12px; padding-top: 12px; border-top: 1px solid rgba(var(--color-foreground-rgb, 18 18 18), .08); }
      .boho-bundle__price-original { color: rgba(var(--color-foreground-rgb, 18 18 18), .58); text-decoration: line-through; }
      .boho-bundle__price-discounted { display: flex; align-items: center; gap: 8px; flex-wrap: wrap; margin-top: 4px; font-weight: 700; }
      .boho-bundle__cta { display: none; width: 100%; margin-top: 12px; border: 0; background: #2f55ff; color: #fff; font-weight: 700; }
      .boho-bundle__cta.is-visible { display: block; }
      .boho-bundle__cta:disabled { opacity: .6; cursor: wait; }
      .boho-bundle__feedback { display: none; margin-top: 10px; font: inherit; font-size: .9rem; }
      .boho-bundle__feedback.is-visible { display: block; }
      .boho-bundle__feedback--success { color: #2f7d32; }
      .boho-bundle__feedback--error { color: #b42318; }
      body.${BODY_MODE_CLASS} .${HIDDEN_CLASS} { display: none !important; }
    `;
    document.head.appendChild(style);
  }

  function createBundleMarkup() {
    const existing = document.getElementById(WRAP_ID);
    if (existing) return existing;
    const wrap = document.createElement('div');
    wrap.className = 'boho-bundle';
    wrap.id = WRAP_ID;
    wrap.style.display = 'none';
    wrap.innerHTML = `
      <p class="boho-bundle__intro">Choose one cover by size, or switch to a ready-made bundle. Select colour first for both options.</p>
      <div class="boho-bundle__mode" role="group" aria-label="Purchase option">
        <button class="boho-bundle__mode-btn is-active" data-boho-mode="single" type="button">Single cover</button>
        <button class="boho-bundle__mode-btn" data-boho-mode="bundle" type="button">Bundle & save</button>
      </div>
      <div class="boho-bundle__panel" id="boho-bundle-panel" hidden>
        <div class="boho-bundle__heading"><span>Bundle & Save</span></div>
        <div class="boho-bundle__options">
          <button class="boho-bundle__btn" data-boho-bundle="one-seater" type="button"><span class="boho-bundle__btn-name">One Seater Bundle</span><span class="boho-bundle__save-pill">10% off</span></button>
          <button class="boho-bundle__btn" data-boho-bundle="two-seater" type="button"><span class="boho-bundle__btn-name">Two Seater Bundle</span><span class="boho-bundle__save-pill">15% off</span></button>
          <button class="boho-bundle__btn" data-boho-bundle="three-seater" type="button"><span class="boho-bundle__btn-name">Three Seater Bundle</span><span class="boho-bundle__save-pill">15% off</span></button>
          <button class="boho-bundle__btn" data-boho-bundle="l-shaped" type="button"><span class="boho-bundle__btn-name">L-Shaped Bundle</span><span class="boho-bundle__save-pill">15% off</span></button>
        </div>
        <div class="boho-bundle__details" id="boho-bundle-details">
          <div class="boho-bundle__details-title" id="boho-bundle-title"></div>
          <ul id="boho-bundle-list"></ul>
          <div class="boho-bundle__pricing" id="boho-bundle-pricing" style="display:none">
            <div class="boho-bundle__price-original" id="boho-bundle-original"></div>
            <div class="boho-bundle__price-discounted"><span id="boho-bundle-discounted"></span><span class="boho-bundle__save-pill" id="boho-bundle-price-pill"></span></div>
          </div>
        </div>
        <button class="boho-bundle__cta" id="boho-bundle-cta" type="button">Add bundle to cart</button>
        <div class="boho-bundle__feedback" id="boho-bundle-feedback"></div>
      </div>
    `;
    return wrap;
  }

  function markSingleControls() {
    const sizeGroup = findOptionGroup(['size', 'specification']);
    if (sizeGroup) sizeGroup.classList.add(HIDDEN_CLASS);
    getProductForms().forEach((form) => {
      form.querySelectorAll('quantity-selector-component, add-to-cart-component, .accelerated-checkout-block, .shopify-payment-button, .product-form-text__error').forEach((element) => element.classList.add(HIDDEN_CLASS));
    });
  }

  function positionBundleControls() {
    const wrap = createBundleMarkup();
    const colorGroup = findOptionGroup(['color', 'colour']);
    const sizeGroup = findOptionGroup(['size', 'specification']);
    if (colorGroup && colorGroup.parentNode) colorGroup.parentNode.insertBefore(wrap, colorGroup.nextSibling);
    else if (sizeGroup && sizeGroup.parentNode) sizeGroup.parentNode.insertBefore(wrap, sizeGroup);
    markSingleControls();
    wrap.style.display = '';
    applyMode(currentMode);
  }

  function schedulePosition() {
    window.setTimeout(positionBundleControls, 0);
    window.setTimeout(positionBundleControls, 200);
    window.setTimeout(positionBundleControls, 600);
  }

  function getElements() {
    return {
      wrap: document.getElementById(WRAP_ID),
      panel: document.getElementById('boho-bundle-panel'),
      details: document.getElementById('boho-bundle-details'),
      title: document.getElementById('boho-bundle-title'),
      list: document.getElementById('boho-bundle-list'),
      pricing: document.getElementById('boho-bundle-pricing'),
      original: document.getElementById('boho-bundle-original'),
      discounted: document.getElementById('boho-bundle-discounted'),
      pricePill: document.getElementById('boho-bundle-price-pill'),
      cta: document.getElementById('boho-bundle-cta'),
      feedback: document.getElementById('boho-bundle-feedback')
    };
  }

  function resetFeedback() {
    const { feedback } = getElements();
    if (!feedback) return;
    feedback.textContent = '';
    feedback.className = 'boho-bundle__feedback';
  }

  function setFeedback(message, type) {
    const { feedback } = getElements();
    if (!feedback) return;
    feedback.textContent = message;
    feedback.className = 'boho-bundle__feedback is-visible boho-bundle__feedback--' + type;
  }

  function updatePricing(items, bundle) {
    const { pricing, original, discounted, pricePill, cta } = getElements();
    if (!pricing || !original || !discounted || !pricePill || !cta || !bundle) return;
    const pct = Math.round(bundle.discountPct * 100);
    pricePill.textContent = 'Applied with ' + bundle.code;
    cta.textContent = 'Add bundle to cart - save ' + pct + '%';
    if (!items || !items.length) {
      pricing.style.display = 'none';
      return;
    }
    const total = items.reduce((sum, item) => sum + (item.price * item.quantity), 0);
    const discountTotal = items.reduce((sum, item) => sum + (Math.round(item.price * (1 - bundle.discountPct)) * item.quantity), 0);
    original.textContent = 'Was ' + formatMoney(total);
    discounted.textContent = formatMoney(discountTotal);
    pricing.style.display = '';
  }

  function renderBundle(bundleKey) {
    const bundle = BUNDLES[bundleKey];
    const elements = getElements();
    if (!bundle || !elements.wrap || !elements.details || !elements.title || !elements.list || !elements.cta) return;
    activeBundle = bundleKey;
    elements.wrap.querySelectorAll('[data-boho-bundle]').forEach((button) => button.classList.toggle('is-active', button.getAttribute('data-boho-bundle') === bundleKey));
    elements.title.textContent = bundle.label + ' includes:';
    elements.list.innerHTML = bundle.items.map((item) => '<li>' + item.label + '</li>').join('');
    elements.details.classList.add('is-visible');
    elements.cta.classList.add('is-visible');
    resetFeedback();
    updatePricing(resolveBundle(bundleKey, getColor()), bundle);
  }

  function applyMode(mode) {
    const { wrap, panel } = getElements();
    if (!wrap || !panel) return;
    currentMode = mode === 'bundle' ? 'bundle' : 'single';
    const isBundleMode = currentMode === 'bundle';
    document.body.classList.toggle(BODY_MODE_CLASS, isBundleMode);
    panel.hidden = !isBundleMode;
    wrap.querySelectorAll('[data-boho-mode]').forEach((button) => button.classList.toggle('is-active', button.getAttribute('data-boho-mode') === currentMode));
    if (isBundleMode && !activeBundle) renderBundle('one-seater');
    if (!isBundleMode) {
      resetFeedback();
      syncSelectedVariant();
    }
  }

  function getProductFormFromTarget(target) {
    if (!(target instanceof HTMLElement)) return null;
    const form = target.closest('form[action*="/cart/add"]');
    if (!(form instanceof HTMLFormElement)) return null;
    return form.closest('product-form-component[data-product-id="' + PRODUCT_ID + '"]') ? form : null;
  }

  function installEvents() {
    document.addEventListener('change', (event) => {
      if (event.target instanceof HTMLElement && event.target.closest('variant-picker[data-product-id="' + PRODUCT_ID + '"]')) {
        scheduleSync();
        schedulePosition();
        if (activeBundle && document.body.classList.contains(BODY_MODE_CLASS)) renderBundle(activeBundle);
      }
    }, true);

    document.addEventListener('variant:update', (event) => {
      const data = (event.detail || {}).data || {};
      if (data.productId && data.productId !== PRODUCT_ID) return;
      scheduleSync();
      schedulePosition();
      if (activeBundle && document.body.classList.contains(BODY_MODE_CLASS)) window.setTimeout(() => renderBundle(activeBundle), 0);
    });

    document.addEventListener('click', (event) => {
      const target = event.target;
      if (!(target instanceof HTMLElement)) return;
      const modeButton = target.closest('#' + WRAP_ID + ' [data-boho-mode]');
      if (modeButton) {
        applyMode(modeButton.getAttribute('data-boho-mode'));
        return;
      }
      const bundleButton = target.closest('#' + WRAP_ID + ' [data-boho-bundle]');
      if (bundleButton) {
        renderBundle(bundleButton.getAttribute('data-boho-bundle'));
        return;
      }
      if (!document.body.classList.contains(BODY_MODE_CLASS) && target.closest('button[name="add"], add-to-cart-component')) {
        const form = getProductFormFromTarget(target);
        if (form) handleSingleAdd(event, form);
      }
    }, true);

    document.addEventListener('submit', (event) => {
      if (document.body.classList.contains(BODY_MODE_CLASS)) return;
      const form = event.target;
      if (form instanceof HTMLFormElement && form.closest('product-form-component[data-product-id="' + PRODUCT_ID + '"]')) handleSingleAdd(event, form);
    }, true);
  }

  function installBundleCta() {
    const { cta } = getElements();
    if (!cta || cta.dataset.bohoInstalled === 'true') return;
    cta.dataset.bohoInstalled = 'true';
    cta.addEventListener('click', async () => {
      const bundle = BUNDLES[activeBundle];
      if (!bundle) return;
      const items = resolveBundle(activeBundle, getColor());
      if (!items) {
        setFeedback('Some bundle sizes are unavailable in this colour. Please choose another colour.', 'error');
        return;
      }
      cta.disabled = true;
      cta.textContent = 'Adding...';
      resetFeedback();
      const completeMutation = beginSdCartMutation();
      try {
        await addBundleToCart(items);
        const updateData = await applyDiscountCode(bundle.code);
        const itemCount = items.reduce((sum, item) => sum + item.quantity, 0);
        dispatchCartEvent(updateData, 'boho-bundle-cta', itemCount);
        openCartDrawer();
        setFeedback('Bundle added to cart and discount applied.', 'success');
      } catch (error) {
        console.error(error);
        setFeedback(error instanceof Error ? error.message : 'Could not add the bundle to cart.', 'error');
      } finally {
        completeMutation();
        cta.disabled = false;
        updatePricing(items, bundle);
      }
    });
  }

  function install() {
    if (!isTargetProductPage()) return;
    injectStyles();
    scheduleSync();
    schedulePosition();
    installEvents();
    window.setTimeout(installBundleCta, 50);
    window.setTimeout(installBundleCta, 300);
    window.setTimeout(installBundleCta, 800);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', install);
  else install();
})();
